import { dataBR, MASCARA_CPF, PERFIS_INFO } from "@vetbolso/core";
import { mascarar } from "@vetbolso/ui";
import { useState } from "react";
import { salvarPerfil } from "../api.ts";
import { Cabeca } from "../comp.tsx";
import { useApp, useBase } from "../estado.tsx";
import { aplicarTema, type Tema, temaAtual } from "../tema.ts";

const TEMAS: [Tema, string][] = [
  ["claro", "Claro"],
  ["escuro", "Escuro"],
];

function Aparencia() {
  const [tema, setTema] = useState(temaAtual);
  return (
    <div className="card">
      <h3>Aparência</h3>
      <p className="sub">O tema claro é o padrão. O escuro ajuda em plantão noturno e vale só neste aparelho.</p>
      {/* biome-ignore lint/a11y/useSemanticElements: grupo de botões de alternância, como as espécies */}
      <div className="chips" role="group" aria-label="Tema">
        {TEMAS.map(([id, nome]) => (
          <button
            key={id}
            type="button"
            className="chip"
            aria-pressed={tema === id}
            onClick={() => {
              aplicarTema(id);
              setTema(id);
            }}
          >
            {nome}
          </button>
        ))}
      </div>
    </div>
  );
}

const dataHora = (ms: number) =>
  new Date(ms).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });

export function TelaConta() {
  const { estado, recarregar, sincronizando, sairDaConta, perfil, setPerfil } = useApp();
  const base = useBase();
  if (estado.fase !== "pronta") return null;
  const { meta, sessao, online } = estado;
  const limite = Math.min(meta.expiraEm, meta.confirmadoEm + 7 * 86_400_000);
  return (
    <>
      <Cabeca titulo="Conta e sincronização" />
      <div className="card">
        <h3>Base de consulta</h3>
        <dl className="kv">
          <dt>Versão</dt>
          <dd className="mono">{meta.versao}</dd>
          <dt>Conteúdo conferido</dt>
          <dd>{dataBR(base.meta?.conferidoEm)}</dd>
          <dt>Baixada em</dt>
          <dd>{dataHora(meta.salvoEm)}</dd>
          <dt>Acesso confirmado</dt>
          <dd>{dataHora(meta.confirmadoEm)}</dd>
          <dt>Offline até</dt>
          <dd>{dataHora(limite)}</dd>
        </dl>
        {!online ? (
          <div className="alert warning">Sem conexão. A base salva vale até {dataHora(limite)}; conecte-se antes para renovar.</div>
        ) : null}
        <button type="button" className="btn ghost" disabled={sincronizando} onClick={() => recarregar()}>
          {sincronizando ? "Sincronizando…" : "Sincronizar agora"}
        </button>
      </div>
      {sessao ? (
        <div className="card">
          <h3>Conta</h3>
          <dl className="kv">
            <dt>E-mail</dt>
            <dd>{sessao.usuario.email}</dd>
            <dt>Plano</dt>
            <dd>{sessao.acesso.plano === "estudante" ? "Estudante" : sessao.acesso.motivo === "equipe" ? "Equipe" : "Completo"}</dd>
          </dl>
          <div className="group-label">Perfil</div>
          <div className="chips">
            {PERFIS_INFO.map((p) => (
              <button key={p.id} type="button" className="chip" aria-pressed={perfil === p.id} onClick={() => setPerfil(p.id)}>
                {p.nome}
              </button>
            ))}
          </div>
        </div>
      ) : null}
      <Aparencia />
      <button type="button" className="btn ghost" onClick={() => sairDaConta()}>
        Sair e apagar a base deste aparelho
      </button>
    </>
  );
}

/** CPF entra uma vez para vincular a compra; o servidor guarda só o hash. */
export function FormCpf({ aoVincular }: { aoVincular?: () => void }) {
  const [cpf, setCpf] = useState("");
  const [erro, setErro] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);
  return (
    <form
      className="card"
      onSubmit={async (e) => {
        e.preventDefault();
        setEnviando(true);
        setErro(null);
        try {
          await salvarPerfil({ cpf });
          aoVincular?.();
        } catch (x) {
          setErro(x instanceof Error ? x.message : "não foi possível vincular");
        } finally {
          setEnviando(false);
        }
      }}
    >
      <h3>Já comprou? Vincule pelo CPF</h3>
      <p className="sub">Use o mesmo CPF informado no checkout. Guardamos só uma impressão digital do número, nunca o CPF em si.</p>
      <div className="field">
        <label htmlFor="cpf">CPF</label>
        <input
          id="cpf"
          className="num"
          inputMode="numeric"
          autoComplete="off"
          placeholder="000.000.000-00"
          value={cpf}
          onChange={(e) => setCpf(mascarar(e, MASCARA_CPF))}
          required
        />
      </div>
      {erro ? <p className="erro">{erro}</p> : null}
      <button type="submit" className="btn" disabled={enviando}>
        {enviando ? "Verificando…" : "Vincular e verificar acesso"}
      </button>
    </form>
  );
}
